import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  // AiOutlineTwitter,
  // AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              A LITTLE ABOUT  <span className="purple"> ME </span>
            </h1>
            <p className="home-about-body">
              My name is Tanish Kumar Gaur . Apart from coding most of the times either i play football or games.
              <br /><br />
             I completed my schooling at St. Mary'S Convent Senior Secondary School and am currently pursuing b-tech in Computer Science from Acropolis Institute Of Research And Technology
              <br /><br />
              I am fluent in 
              <i>
                <b className="purple">  Python </b>
              </i>
              {/* <br />
              <br />
              The subjects that interest me most are
              <i>
                <b className="purple"> Quantum Algorithms, Neural Networks </b> and areas related to{" "}
                <b className="purple">
                  Abstract Algebra.
                </b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/G8ur"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://in.linkedin.com/in/tanish-kumar-gaur-126810202"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
